import OrderingSettings from "../../components/feature/settings/ordering/ordering-settings";
import { useSettingsData } from "../../contexts/SettingsDataContext";
import SettingsTabPage from "../../components/feature/settings/settings-tab-page";
import { useRouter } from "expo-router";
import { useEffect } from "react";

const OrderingTab = () => {
  const { isOrderingAgent } = useSettingsData();
  const router = useRouter();

  useEffect(() => {
    if (!isOrderingAgent) {
      router.replace("/settings");
    }
  }, [isOrderingAgent]);

  return (
    <SettingsTabPage>
      <OrderingSettings />
    </SettingsTabPage>
  );
};

export default OrderingTab;
